import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import { useNavigate } from 'react-router-dom';

import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import 'mapbox-gl/dist/mapbox-gl.css';
mapboxgl.accessToken = 'pk.eyJ1IjoiaGFycnltb250YW5vIiwiYSI6ImNqZWY0bDcyaTFkcGYzM28ydHFpaDJxaWcifQ.Wf7aNVePBRWZ9fMy_I81qw';

const maxSpinZoom = 3;
const slowSpinZoom = 2;

function LandingMap({ map, sidebarOpen, extraPadding, menuToggled, deviceStyle = 'desktop' }) {

  useEffect(() => { //adjust map padding
    // console.log('LANDING_MAP', extraPadding);
    // console.log(mapPadding)

    if (deviceStyle == 'mobile') {
      var map_padding = [0, 0];
    }
    else {
      if (!sidebarOpen) {
        if (extraPadding) {
          var map_padding = [0, 290];
        }
        else {
          var map_padding = [0, 0];
        }
      }
      else {
        if (extraPadding) {
          var map_padding = [600, 290];
        }
        else {
          var map_padding = [600, 0];
        }
      }
    }

    if (!menuToggled) {
      map.current.easeTo({
        padding: {
          left: map_padding[0],
          bottom: map_padding[1]
        },
        duration: 500
      });
    }
  }, [menuToggled, deviceStyle]);

}

LandingMap.propTypes = {
  map: PropTypes.object,
  sidebarOpen: PropTypes.bool,
  extraPadding: PropTypes.bool,
  menuToggled: PropTypes.bool,
  deviceStyle: PropTypes.string,
};

export default LandingMap;